import React, {useEffect, useState, useRef} from 'react';
import {Articles} from 'site_version/common/aside/Articles';
import Chat from 'app/components/Chat';
import SurveyStatistics from 'app/components/SurveyStatistics';
import MainPageDescription from 'app/components/MainPageDescription';
import PromoActions from 'site_version/com/aside/PromoActions';
import LootboxAside from './aside/LootboxAside';
import HiddenTemple from 'site_version/com/aside/HiddenTemple';
import {isDesktop, isDesktopLarge, checkingPages} from 'app/utils';
import SmartStoriesMobile from 'app/components/pages/home_page/SmartStories/SmartStoriesMobile';
import AsideStories from 'site_version/com/AsideStories';
import Giveaway from 'site_version/com/Giveaway';
import CasinoWins from 'site_version/com/CasinoWins';
import SocialsList from 'site_version/common/aside/SocialsList';
import Apps from 'site_version/common/aside/Apps';
import {isCasinoPage} from 'app/utils/IsCasinoPage';
import {ScrollUp} from 'app/components/ScrollUp';
import {EgbButton} from 'app/components/Button';
import {getElement} from 'app/utils/getElement';
import ProomPoker from 'app/components/pages/poker/ProomPoker';
import CupAside from 'app/components/pages/cup/CupAside';
import banners from './aside/Banners';
import LetsShowHome from 'app/components/pages/home_page/LetsShow/LetsShowHome';
import PopularGames from 'app/components/pages/home_page/ViewCasinoGames/PopularGames';
import {configStore} from 'app/store/global';
import {isAdmin} from 'app/utils/IsAdmin';
import {useAsideStickyTop} from 'app/utils/useAsideStickyTop';

type AsideProps = {
    hideChat?: boolean;
};

// eslint-disable-next-line complexity
const Aside: React.FC<AsideProps> = ({hideChat}) => {
    const [showWidget, setShowWidget] = useState(false);
    const showWidgetRef = useRef(false);
    const desktop = isDesktop();
    const moveToLeftAside = isDesktopLarge() && isAdmin();
    const isHomePage = checkingPages.isHomePage();

    const {ref: reactAsideContentRef, top: asideTop} = useAsideStickyTop(desktop, true);

    useEffect(() => {
        const handleScroll = (event: Event): void => {
            if (getElement('.casino-page') === null) {
                if (showWidgetRef.current) {
                    setShowWidget(false);
                }

                return;
            }

            const blockWidth = -60;
            const target = event.target as Document;
            const {top} = target.body.getBoundingClientRect();
            const shouldShow = top <= blockWidth;

            if (showWidgetRef.current !== shouldShow) {
                setShowWidget(shouldShow);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        showWidgetRef.current = showWidget;
    }, [showWidget]);

    const topStyleAsideContent = desktop ? {top: asideTop} : {};
    const shouldShowOnAllPagesExcept = (page: string) => !window.location.pathname.includes(page) && !configStore.isDevelopment;

    return (
        <aside className="aside">
            <div
                ref={reactAsideContentRef}
                id="aside-inner-content"
                className="aside__inner"
                style={topStyleAsideContent}
            >

                {!desktop && <SmartStoriesMobile />}

                {desktop && <AsideStories />}

                <PromoActions />

                {!hideChat && <Chat />}

                {!moveToLeftAside && shouldShowOnAllPagesExcept('/cup') && <CupAside />}

                {shouldShowOnAllPagesExcept('/poker') && <ProomPoker embedded />}

                <SocialsList />

                {isCasinoPage() && <CasinoWins />}

                <Giveaway itemClassName="giveaway" />

                <LootboxAside />

                {desktop && !isHomePage && <Articles hidePromotions={moveToLeftAside} />}

                {!desktop && isHomePage && <LetsShowHome />}

                {!desktop && isHomePage && <PopularGames nameForSliderControls="popular-games-aside"/>}

                <HiddenTemple />

                {!moveToLeftAside && <SurveyStatistics/>}

                {!configStore.MOBILE_WRAPPER && <Apps />}

                {(!isHomePage && desktop || !desktop) && <MainPageDescription/>}

                {banners()}
            </div>

            <ScrollUp
                show={showWidget}
                behavior={'instant'}
                element={getElement('.casino-page')}
                icon={<EgbButton name={'back_to_top'} />}
            />
        </aside>
    );
};

export default Aside;
